$('a[href^="#"]').on('click',function(e) {
    e.preventDefault();
    var target = this.hash;
    var header = $('.header').height();
    var $target = $(target);
    $('html, body').stop().animate({
        'scrollTop': ($target.offset().top - header)
    }, 900, 'swing', function () {
        window.location.hash = target;
    });
});